import * as React from "react";
import * as i from "../../../../../contracts";
import { CardType, MarketTemplate } from "../../../../../data";
import { SecondaryHeadingContent } from "../../SecondaryHeadingContent";
import { PreLiveOutright } from "../../PreLiveOutright";
import { ViewAllBtn } from "../../ViewAllBtn";
import { getEventTitle } from "../../../../../helpers";
import { BaseDict } from "../../../dict";
export class RenderPreliveOutright extends React.PureComponent <{
    event: i.Event
    markets: i.Market[]
    marketTemplates: MarketTemplate[]
    handlers: {
        betButton: (market: i.Market, selection: i.Selection) => void
    }
    showHeadingNames: boolean
    numberOfSelectionsToShow: number
    viewAllProps: any
    dict: BaseDict
}, {}> {

    renderOutright() {
        return <PreLiveOutright
            key={`prelive-outright-${this.props.event.id}`}
            market={this.props.markets[0]}
            numberOfSelectionsToShow={this.props.numberOfSelectionsToShow}
            betButtonHandler={this.props.handlers.betButton}>
            <ViewAllBtn
                key={`prelive-outright__view_all-${this.props.event.id}`}
                {...this.props.viewAllProps}/>
        </PreLiveOutright>
    }

    render() {
        if (!this.props.markets.length) {
            return <React.Fragment key={`prelive-outright__empty-${this.props.event.id}`}></React.Fragment>
        }
        const title = getEventTitle(this.props.event, this.props.markets[0], this.props.dict.EachWayTag);

        return this.props.showHeadingNames
            ? <SecondaryHeadingContent
                key={`subheading-content-${this.props.event.id}`}
                id={this.props.event.id}
                name={title}
                eventsCount={""}
                shouldExpand={true}
                marketNames={[]}
                marketTemplates={[]}
                cardType={CardType.Regular}>
                    {this.renderOutright()}
                </SecondaryHeadingContent>
            : this.renderOutright()
    }

}